const Button = ({
	topOffset,
	height,
	isOnRightSide,
}: {
	topOffset: number
	height: number
	isOnRightSide?: boolean
}) => (
	<div
		className="absolute w-[8px] rounded-[3px] bg-black"
		style={{
			left: !isOnRightSide ? -10 : undefined,
			right: isOnRightSide ? -10 : undefined,
			top: topOffset,
			height: `${height}px`,
		}}
	/>
)

export const PhoneButtons = () => (
	<>
		<Button topOffset={92} height={22} />
		<Button topOffset={135} height={42} />
		<Button topOffset={185} height={42} />
		<Button topOffset={154} height={61} isOnRightSide />
	</>
)
